import React from "react";

interface Props {
  hidden?: boolean;
}

/**
 * Deprecated — the hidden state is now indicated by the orange tint on
 * the canvas wrapper (CanvasElementItem) plus an eye-slash icon in the
 * hover chrome. Kept as a no-op so existing call sites don't need a
 * per-component cleanup.
 */
const HiddenElementBanner: React.FC<Props> = () => null;

export default HiddenElementBanner;
